<template>
	<v-container fluid>
		<div v-if="!loading ">
			<v-row class="mt-4 total">Self-operated & franchise retail channels</v-row>
			<!--table head-->
			<v-row class="total mt-8" no-gutters>
				<v-col class="tabCell text-left">Available channels</v-col>
				<v-col v-for="item in headers"
					class="tabCell"
					:key="item">{{item}}
				</v-col>
			</v-row>
			<v-expansion-panels multiple v-model="panel">
				<v-expansion-panel>
					<v-expansion-panel-header class="subtitle-2 secondary--text" expand-icon="mdi-menu-down">
						Online self-operated stores
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<!--on-line stores-->
						<div v-if="onlineSelfStores.length">
							<v-row v-for="store in onlineSelfStores"
								:key="store.id"
								no-gutters>
								<v-col class="tabCell text-left">{{ store.name }}</v-col>
								<v-col class="tabCell">{{ store.numbers }}</v-col>
								<v-col class="tabCell">{{ format(constructionInvestments(store))}}</v-col>
								<v-col class="tabCell">{{ format(totalOperationalCosts(0, store.numbers)) }}</v-col>
								<v-col class="tabCell">{{ format(coverage(store)) }}</v-col>
								<v-col class="tabCell">{{ format(store.previousSales) }}</v-col>
								<v-col v-if="isCompanyChain(store.name)" class="tabCell">
									<delete-channel 
										:chan="store"
										:gameId="gameId"
										:round="round">
									</delete-channel>
									<change-channel 
										:chan="store"
										:available="onlineSelfStores"
										:gameId="gameId"
										:round="round">	
									</change-channel>
								</v-col>
								<v-col v-else class="tabCell">
									<delete-channel
										:chan="store"
										:gameId="gameId"
										:round="round"
									></delete-channel>
								</v-col>	
							</v-row>
						</div>
						<v-row class="mt-4" justify="end">
							<add-channel
								:type="0"
								:available="onlineSelfStores"
								:gameId="gameId"
								:round="round"
								:company="company">
							</add-channel>
						</v-row>
					</v-expansion-panel-content>
				</v-expansion-panel>
				<v-expansion-panel>
					<v-expansion-panel-header class="subtitle-2 secondary--text" expand-icon="mdi-menu-down">
						Brick&mortar self-operated stores
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<!--self - brick&mortar store-->
						<div v-if="outlets.length">
							<v-row v-for="outlet in outlets" :key="outlet.id" no-gutters>
								<v-col class="tabCell text-left">{{ outlet.name }}</v-col>
								<v-col class="tabCell">{{ outlet.numbers }}</v-col>
								<v-col class="tabCell">{{ format(constructionInvestments(outlet)) }}</v-col>
								<v-col class="tabCell">{{ format(totalOperationalCosts(1, outlet.numbers)) }}</v-col>
								<v-col class="tabCell">{{ format(coverage(outlet))}}</v-col>
								<v-col class="tabCell">{{ format(outlet.previousSales)}}</v-col>
								<v-col class="tabCell">
									<delete-channel 
										:chan="outlet"
										:gameId="gameId"
										:round="round">
									</delete-channel>
									<change-channel 
										:chan="outlet"
										:available="outlets"
										:gameId="gameId"
										:round="round">	
									</change-channel>
								</v-col>	
							</v-row>
						</div>
						<v-row class="mt-4" justify="end">
							<add-channel 
								:type="1"
								:available="outlets"
								:gameId="gameId"
								:round="round"
								:company="company">
							</add-channel>
						</v-row>
					</v-expansion-panel-content>
				</v-expansion-panel>
				<v-expansion-panel>
					<v-expansion-panel-header class="subtitle-2 secondary--text" expand-icon="mdi-menu-down">
						Franchise stores
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<!--franchise stores-->
						<div v-if="franchises">
							<v-row v-for="franchise in franchises"
								:key="franchise.id"
								no-gutters>
								<v-col class="tabCell text-left">{{ franchise.name }}</v-col>
								<v-col class="tabCell">{{ franchise.numbers }}</v-col>
								<v-col class="tabCell">{{ }}</v-col>
								<v-col class="tabCell">{{  }}</v-col>
								<v-col class="tabCell">{{ format(coverage(franchise)) }}</v-col>
								<v-col class="tabCell">{{ format(franchise.previousSales) }}</v-col>
								<v-col class="tabCell">
									<delete-channel 
										:chan="franchise"
										:gameId="gameId"
										:round="round">
									</delete-channel>
									<change-franchise
										:chan="franchise"
										:gameId="gameId"
										:round="round">	
									</change-franchise>
								</v-col>	
							</v-row>
						</div>
						<v-row class="mt-4" justify="end">
							<sell-franchise
								:outlets="outlets"
								:gameId="gameId"
								:round="round"
								:company="company">	
							</sell-franchise>
						</v-row>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
			<v-row class="mt-4 total">Independent retail chains </v-row>
			<!--table--><!--table head-->
			<v-row class="mt-8 total" no-gutters>
				<v-col v-for="item in headers2"
					class="tabCell"
					:key="item">{{item}}
				</v-col>
			</v-row>
			<v-expansion-panels multiple v-model="panel2">
				<v-expansion-panel>
					<v-expansion-panel-header class="subtitle-2 accentColor" expand-icon="mdi-menu-down">
						Online channels
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-row v-for="chan in marketplaces" :key="chan.id" no-gutters>
							<v-col class="tabCell text-left">{{ chan.name }}</v-col>
							<v-col class="tabCell accentColor">{{ status(chan) }}</v-col>
							<v-col class="tabCell">{{ margin(chan) }}</v-col>
							<v-col class="tabCell">{{ chan.numbers }}</v-col>
							<v-col class="tabCell">{{ flatFee(chan) }}</v-col>
							<v-col class="tabCell">{{ entryFee(chan) }}</v-col>
							<v-col class="tabCell">{{ format(chan.sales) }}</v-col>
							<v-col class="tabCell">{{ format(coverage(chan)) }}</v-col>
							<v-col v-if="status(chan)" class="tabCell">
								<!--suspend from the chain (delete)-->
								<suspend
									:chan="chan"
									:gameId="gameId"
									:round="round">
								</suspend>
								<change 
									:chain="chan"
									:channel="channelToChange(chan)"
									:gameId="gameId"
									:round="round">
								</change>
							</v-col>
							<v-col v-else class="tabCell">
								<register 
									:type="3"
									:chan="chan"
									:gameId="gameId"
									:round="round"
									:company="company">
								</register>	
							</v-col>
						</v-row>
					</v-expansion-panel-content>
				</v-expansion-panel>
				<v-expansion-panel>
					<v-expansion-panel-header class="subtitle-2 accentColor" expand-icon="mdi-menu-down">
						Brick & mortar channels
					</v-expansion-panel-header>
					<v-expansion-panel-content>
						<v-row v-for="chan in chains" :key="chan.id" no-gutters>
							<v-col class="tabCell text-left">{{ chan.name }}</v-col>
							<v-col class="tabCell accentColor">{{ status(chan) }}</v-col>
							<v-col class="tabCell">{{ margin(chan) }}</v-col>
							<v-col class="tabCell">{{ chan.numbers }}</v-col>
							<v-col class="tabCell">{{ flatFee(chan) }}</v-col>
							<v-col class="tabCell">{{ entryFee(chan) }}</v-col>
							<v-col class="tabCell">{{ format(chan.sales) }}</v-col>
							<v-col class="tabCell">{{ format(coverage(chan))}}</v-col>
							<v-col v-if="status(chan)" class="tabCell">
								<suspend
									:chan="chan"
									:gameId="gameId"
									:round="round">
								</suspend>
								<change 
									:chain="chan"
									:channel="channelToChange(chan)"
									:gameId="gameId"
									:round="round">
								</change>
							</v-col>
							<v-col v-else class="tabCell">
								<register
									:type="4"
									:chan="chan"
									:gameId="gameId"
									:round="round"
									:company="company">
								</register>
							</v-col>
						</v-row>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
		</div>
		<div v-else class="text-center">
			<loader></loader>
		</div> 
	</v-container>
</template>
<script>
	import addChannel from '../channels/addChannel.vue'
	import deleteChannel from '../channels/deleteChannel.vue'
	import changeChannel from '../channels/changeChannel.vue'
	import sellFranchise from '../channels/sellFranchise.vue'
	import changeFranchise from '../channels/changeFranchise.vue'

	import register from '../channels/registerInChain.vue'
	import suspend from '../channels/suspendFromChain.vue'
	import change from '../channels/changeInChain.vue'

	import numeral from 'numeral'
	import Loader from '../../layouts/Loader.vue'

	export default {
		props: ['gameId', 'round', 'company'],
		data (){
			return {
				icon: 'arrow_right',
				headers: ['Numbers', 'Investments in store constructions', 'Total operational costs ', 'Peak market coverage', 'Sales units (last year)', 'Action'],
				headers2: ['Available channels (multibrand)', 'Status', 'Retail margin (% of sales)', 'Store count', 'Annual flat fee', 'Entry fee', 'Sales (last year)', 'Peak market coverage (total)', 'Action'],
				panel: [],
				panel2: []
			}
		},		
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			channelParams () {
				return this.$store.getters.channelParams
			},
			onlineSelfStores () {
				return this.$store.getters.onlineSelfStores
			},
			outlets () {
				return this.$store.getters.outlets
			},
			channels () {
				return this.$store.getters.channels
			},
			franchises () {
				return this.$store.getters.franchises
			},
			marketplaces () {
				return this.$store.getters.marketplaces
			},
			chains () {
				return this.$store.getters.chains
			}, 
			inIndependentChains () {
				return this.$store.getters.inIndependentChains
			}
		},
		methods: {
			//format in numeral
			format (param) {
				return numeral(param).format('0,0[.]0')
			},
			status (channel) {
				const inChains = this.inIndependentChains
				if (inChains.length) {
					const registered = inChains.find(chan => chan.name == channel.name)
					if (registered) return 'registered'
					else return ''
				}
				return ''
			},
			isCompanyChain (name) {
				const is = name.search(this.company)
				if (is === -1) return false
				else return true				
			},
			constructionInvestments (channel) {
				if (channel.investments) {
					return channel.investments
				}
				else {
					return this.channelParams[channel.type].constructionInvestments
				}
			},
			totalOperationalCosts (type, numbers) {
				const tot = this.channelParams[type].operationalCosts * numbers
				return tot
			},
			margin (channel) {
				return numeral(channel.margin).format('0 %')
			},
			flatFee (channel) {
				const fee = channel.flatFee
				if (fee > 0) return numeral(fee).format('0,0[.]0')
				else return ' - '
			},
			entryFee (channel) {
				const fee = channel.entryFee
				if (fee > 0) return numeral(fee).format('0,0[.]0')
				else return ' - '
			},
			coverage (channel) {
				let stores = channel.numbers
				if (!parseInt(channel.numbers)) stores = 1
				
				const totalCov = stores * channel.coverage
				return totalCov
			},
			noFocus (event) {
				event.target.blur()//no focus
			},
			channelToChange (chan) {
				return this.inIndependentChains.find(channel => channel.name === chan.name)
			}
		},
		components: {
			addChannel,
			deleteChannel,
			changeChannel,
			sellFranchise,
			changeFranchise,

			register,
			suspend,
			change,
			Loader
		},
		
	}
</script>
